import {
  Box,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import useGainAllocations from "@hooks/useGainAllocations";
import { CMSAllocation } from "@components/VaultTabs/VaultAprReports";
import { FaCircle } from "react-icons/fa6";
import BaseImage from "@components/BaseImage";

type StrategiesProps = {
  columns: {
    label: string;
    accessor: string;
  }[];
  cmsAllocations: CMSAllocation[];
};

const Strategies = ({ columns, cmsAllocations }: StrategiesProps) => {
  const { allocations } = useGainAllocations(cmsAllocations);

  return (
    <Box p="0 16px 16px 16px">
      <Box overflowX={"auto"} w="100%">
        <Table variant="unstyled" p="0">
          <Thead>
            <Tr>
              {columns.map((col, idx) => (
                <Th
                  key={`th_${idx}`}
                  fontSize="14px"
                  lineHeight="16px"
                  fontWeight="400"
                  p={2}
                  textTransform="none"
                >
                  {col.label}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {Object.values(allocations).map((row: any, index: number) => (
              <Tr key={`tb_${index}`}>
                <Td p={2}>
                  <Flex align="center" gap={2}>
                    {row.icon_src ? (
                      <BaseImage
                        src={row.icon_src}
                        alt=""
                        width={14}
                        height={14}
                        style={{ borderRadius: "50%" }}
                      />
                    ) : (
                      <Icon as={FaCircle} boxSize={3} color="black" />
                    )}
                    <Text fontSize="14px" lineHeight="16px" fontWeight="600">
                      {row.name}
                    </Text>
                  </Flex>
                </Td>
                <Td p={2}>
                  <Text fontSize="14px" lineHeight="16px" fontWeight="600">
                    {row.allocation ? row.allocation : "-"}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default React.memo(Strategies);
